import { buildQueryString } from '../serviceUtils';
import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for managing workflow information
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({});

    const queryTickets = (action) => api.get(ApiPaths.QUERY_TICKETS(buildQueryString(action)));
    const getTicket = (ticketId) => api.get(ApiPaths.GET_TICKET(ticketId));
    const completeWorkflowTask = (ticketId, workflowTaskData) => api.post(ApiPaths.COMPLETE_TICKET_WORKFLOW(ticketId), workflowTaskData);
    const getEligibleAddonProducts = (ticketId) => api.get(ApiPaths.GET_ELIGIBLE_ADD_ONS(ticketId));
    const openAndAssignTicket = (ticketId, payload) => api.put(ApiPaths.UPDATE_TICKET(ticketId), payload);
    const assignTickets = (associateId, payload) => api.put(ApiPaths.ASSIGN_TICKETS(associateId), payload);
    const touchTicket = (ticketId) => api.put(ApiPaths.TOUCH_TICKET(ticketId));
    const getTicketNotes = (ticketId) => api.get(ApiPaths.GET_TICKET_NOTES(ticketId)); 
    const createTicketNote = (payload) => api.post(ApiPaths.ADD_TICKET_NOTE, payload);
    // Return back a collection of functions
    return {
        queryTickets, getTicket, completeWorkflowTask, getEligibleAddonProducts, openAndAssignTicket, 
        assignTickets, touchTicket, getTicketNotes, createTicketNote
    }
}

// let's return back our create method as the default.
export default {
    create
}
